import * as React from "react"
import type { SVGProps } from "react"
const SvgLineFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M9 18.57h6q.42 0 .71-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29H9a1 1 0 0 0-.71.29 1 1 0 0 0-.29.71q0 .42.29.71.29.3.71.29m0-4h6q.42 0 .71-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.29H9a1 1 0 0 0-.71.29 1 1 0 0 0-.29.71q0 .42.29.71.29.3.71.29m-3 8q-.82 0-1.41-.59A2 2 0 0 1 4 20.57v-16q0-.82.59-1.41A2 2 0 0 1 6 2.57h7.18a2 2 0 0 1 1.4.57L19.43 8A2 2 0 0 1 20 9.4v11.18q0 .82-.59 1.41a2 2 0 0 1-1.41.59zm7-14v-4H6v16h12v-11h-4a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71" />
  </svg>
)
export default SvgLineFile
